/* NEBBIA: grid-density view switcher for the collection/search product grid.
   Deliberately simple and dependency-free -- just toggles a class on
   #product-grid and the pressed state on the two buttons. Uses event
   delegation on `document` (rather than binding listeners to the buttons
   directly) so it keeps working even though Dawn's facets.js re-renders
   #ProductGridContainer's innerHTML on every filter/sort change: the
   buttons themselves live in the facets sidebar, not inside that
   re-rendered container, so they're never destroyed and never need
   re-binding. See the comment in snippets/facets.liquid for the one
   known tradeoff (the density choice itself resets after a filter/sort
   change, since #product-grid is part of what gets replaced). */
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-grid-density]');
  if (!button) return;

  var grid = document.getElementById('product-grid');
  if (!grid) return;

  var isCompact = button.dataset.gridDensity === 'compact';
  grid.classList.toggle('nb-grid--compact', isCompact);

  document.querySelectorAll('[data-grid-density]').forEach(function (btn) {
    var active = btn === button;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
});